const isDefined = value => value !== null && value !== undefined;

export default isDefined;
